const BA_TIMEZONE = 'America/Argentina/Buenos_Aires';

export const formatDateTimeAr24 = (value: string | Date): string => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  const datePart = new Intl.DateTimeFormat('es-AR', {
    timeZone: BA_TIMEZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);

  const timePart = new Intl.DateTimeFormat('es-AR', {
    timeZone: BA_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  }).format(date);

  return `${datePart}, ${timePart}`;
};

export const formatTime24 = (timeValue: string): string => {
  const value = String(timeValue || '').trim();
  if (!value) return '-';

  const parts = value.split(':').map((part) => Number(part));
  if (parts.length < 2 || parts.some((part) => !Number.isFinite(part))) return value;

  const hours = Math.max(0, Math.min(23, parts[0]));
  const minutes = Math.max(0, Math.min(59, parts[1]));
  const seconds = parts.length >= 3 ? Math.max(0, Math.min(59, parts[2])) : 0;

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};
